const resumeData = [

    {
        "projects": [
            {
                "name": "No Free Toes",
                "displayName": "No Free Toes",
                "summary": "A full stack application using the MERN stack. It is a booking platform for service-based businesses like, 'Hair Cuts, Eye Lashes, etc...",
                "website": "https://no-free-toes-v2-cf42c7c1cbf7.herokuapp.com/",
                "githubUrl": "https://github.com/brianalegre/No-Free-Toes",
                "primaryLanguage": "Javascript"
            },
            {
                "name": "OldEgg",
                "displayName": "OldEgg",
                "summary": "OldEgg is a full-stack e-commerce application for buying electronics",
                "website": "https://oldegg-v2-5432d4798f08.herokuapp.com/",
                "githubUrl": "https://github.com/brianalegre/OldEgg",
                "primaryLanguage": "Javascript"
            },
            {
                "name": "The Movie Library",
                "displayName": "The Movie Library",
                "summary": "The Movie Library is front-end application where users can search and find information on the latest and/or popular movies",
                "website": "https://brianalegre.github.io/Movie-Library/",
                "githubUrl": "https://github.com/brianalegre/Movie-Library",
                "primaryLanguage": "Javascript"
            },
            {
                "name": "Tech Blog",
                "displayName": "Tech Blog",
                "summary": "Tech Blog is a full-stack application, where uesr can post their thoughts, and comment on other users' posts",
                "website": "https://alegre-techblog-v1-3aa2ffff496c.herokuapp.com/",
                "githubUrl": "https://github.com/brianalegre/14-MVC-Techblog",
                "primaryLanguage": "Javascript"
            },
            {
                "name": "Weather Dashboard",
                "displayName": "Weather Dashboard",
                "summary": "Weather Dashboard is a front-end application, utilizing a third party API, where users can search any city's weather",
                "website": "https://brianalegre.github.io/06-Server-Side-APIs-Homework/",
                "githubUrl": "https://github.com/brianalegre/06-Server-Side-APIs-Homework",
                "primaryLanguage": "Javascript"
            },
            {
                "name": "Pokémon Quiz",
                "displayName": "Pokémon Quiz",
                "summary": "Pokémon Quiz is a front-end application where users guess the Pokémon's name, and earn points while doing so",
                "website": "https://brianalegre.github.io/04-Web-APIs-Homework/",
                "githubUrl": "https://github.com/brianalegre/04-Web-APIs-Homework",
                "primaryLanguage": "Javascript"
            },
        ]
    },
    {
        "work": [
            {
                "company": "Western Digital Corp.",
                "position": "Lead Technician V",
                "website": "https://www.westerndigital.com/",
                "location": "Irvine, CA",
                "isCurrentRole": true,
                "summary": "Improving user experience and data recall/collection using frontend and backend technoligies.",
                "highlights": [
"Spearheaded the development of web application features that reduced manual test processes by 80% and server storage management.",
"Reduced 80% of manual test processes - which reduced the average testing time from 1440 to 300 hours per test suite.",
"Created a server storage monitoring system which alerted users on actionable items to help maintain storage threshold to effectively store server logs and uptime.",
"Maintained accurate documentation of test procedures, results, and equipment calibration records to ensure compliance with industry standards and regulations."
                ],
                "startDate": "October 1st, 2012",
                "start": {
                    "year": 2012,
                    "month": 10
                }
            }
        ]
    },
    {
        "education": [
            {
                "institution": "University of California, Irvine",
                "area": "Computer Science",
                "studyType": "Coding Certificate",
                "startDate": "",
                "endDate": "2022",

            },
            {
                "institution": "Westwood College",
                "area": "Computer Science",
                "studyType": "Bachelor of Science",
                "startDate": "",
                "endDate": "2009",
            }
        ],
    },
    {
        "stacks": [
            {
                "keywords": [
                    "NextJS",
                    "React",
                    "JavaScript",
                    "jQuery",
                    "HTML",
                    "Figma",
                    "CSS",
                    "Bootstrap",
                    "Tailwind",
                    "Material UI",
                    "Framer Motion",
                ],
                "name": "Frontend"
            },
            {
                "keywords": [
                    "NodeJS",
                    "ExpressJS",
                    "ASP.NET",
                    "Mongoose",
                    "GraphQL",
                    "Apollo GraphQL",
                ],
                "name": "Backend"
            },
            {
                "keywords": [
                    "AWS S3",
                    "MongoDB",
                    "MySQL",
                    "MSSQL",

                ],
                "name": "Database"
            },
            {
                "keywords": [
                    "Javascript",
                    "jQuery",
                    "Bash",
                    "Powershell",
                    "C#",

                ],
                "name": "Languages"
            },
        ],
    },
    {
        "me": {
            "name": "Brian Alegre",
            "picture": "./images/selfie.jpg",
            "title": "Software Engineer | Full Stack Developer",
            "email": "brianalegre1231@gmail.com",
            "location": {
                "city": "Orange County",
                "region": "California",
                "countryCode": "USA"
            },
            "profiles": [
                {
                    "network": "GitHub",
                    "username": "brianalegre",
                    "url": "https://github.com/brianalegre"
                },
                {
                    "network": "LinkedIn",
                    "url": "https://www.linkedin.com/in/brian-alegre",
                    "username": "brian-alegre"
                },
                {
                    "network": "Portfolio",
                    "url": "https://brianalegre.github.io/20-React-Portfolio/"
                }
            ]
        }
    }
]

export default resumeData